export type ResourcePileProps = {
  name: string;
  value: number;
  max?: number;
};

export class ResourcePile implements ResourcePileProps {
  name: string;
  value: number;
  max?: number;

  constructor(props: ResourcePileProps) {
    Object.assign(this, props);
  }
  canPay(count: number) {
    return count <= this.value;
  }
  pay(count: number) {
    if (!this.canPay(count)) {
      throw new Error(`cannot pay ${count} ${this.name}`);
    }
    this.value -= count;
  }
  add(count: number) {
    return this.pay(-count);
  }
  multiply(factor: number) {
    return new ResourcePile({
      ...this,
      value: this.value * factor,
    });
  }
}
